import InstantClick from 'instantclick'

export default () => {
  InstantClick.init();
}
